import { styled } from '@mui/material';
import { NavLink as Link } from 'react-router-dom';
import { COLORS } from '../../../theme/color';

export const NavLinkCon = styled(Link)`
  width: 100%;
  padding: 0.875rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  color: ${COLORS.MainBlack};
  font-weight: 500;
  font-size: 0.875rem;
  text-transform: capitalize;
  border-radius: 8px;
  margin: 0 0.5rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    background: linear-gradient(135deg, ${COLORS.MainBlue} 0%, ${COLORS.SecondaryBlue} 100%);
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;
  }

  .navIcon {
    background-color: ${COLORS.MildGray};
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.25rem;
    border-radius: 8px;
    overflow: hidden;
    margin-right: 1rem;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }

  /* Text content */
  > *:not(.navIcon) {
    position: relative;
    z-index: 1;
  }

  &:hover {
    color: ${COLORS.MainBlue};
    transform: translateX(4px);

    &::before {
      width: 4px;
    }

    .navIcon {
      background-color: ${COLORS.SecBlue};
      transform: scale(1.05);
    }
  }

  /* Active state */
  &.nav-link--active {
    background: linear-gradient(135deg, ${COLORS.MainBlue} 0%, ${COLORS.SecondaryBlue} 100%);
    color: ${COLORS.White};
    box-shadow: 0 4px 12px rgba(47, 77, 196, 0.2);
    transform: translateX(4px);

    &::before {
      width: 4px;
      background: ${COLORS.White};
    }

    .navIcon {
      background-color: rgba(255, 255, 255, 0.2);
      transform: scale(1.05);
    }

    &:hover {
      color: ${COLORS.White};
      transform: translateX(6px);
    }
  }

  /* Focus state for accessibility */
  &:focus {
    outline: 2px solid ${COLORS.MainBlue};
    outline-offset: 2px;
  }
`;

// export const active = {
//   backgroundColor: `${COLORS.MainBlue}`,
//   color: '#fff'
// };
